module.exports = __webpack_public_path__ + "img/chapter7begin.90ad7a2d.jpg";